import ExpirationTypeModel        from '@models/shop/ExpirationTypeModel';
import ProductTemplateStatusModel from '@models/shop/ProductTemplateStatusModel';
import ProductTypeModel           from '@models/shop/ProductTypeModel';
import VatModel                   from '@models/shop/VatModel';
import doc                        from '@widesk-core/decorators/doc';
import model                      from '@widesk-core/decorators/model';
import ShopServiceModel           from '@/models/ShopServiceModel';
import TimestampAble              from '@widesk-core/models/traits/TimestampAble';
import Blamable                   from '@/models/traits/Blamable';
import Translatable               from '@widesk-core/models/traits/Translatable';
import DeliverableTemplateModel   from '@models/shop/DeliverableTemplateModel';

@model.urnResource('product_template')
@doc.path('/product_templates/{?id}')
export default class ProductTemplateModel extends Blamable(TimestampAble(Translatable(ShopServiceModel, {
	'description': true,
	'shortDescription': true,
	'termsOfUse': true,
	'instructionsOnTicket': true,
}))) {
	private declare _tsFilters: {
		'createdAt[after]': string | Date | Dayjs;
		'createdAt[before]': string | Date | Dayjs;
		'createdAt[strictly_after]': string | Date | Dayjs;
		'createdAt[strictly_before]': string | Date | Dayjs;
		'label': string;
		'productTemplateStatus': id;
		'productTemplateStatus.reference': Shop_ProductTemplateStatusReference;
		'productType': id;
		'updatedAt[after]': string | Date | Dayjs;
		'updatedAt[before]': string | Date | Dayjs;
		'updatedAt[strictly_after]': string | Date | Dayjs;
		'updatedAt[strictly_before]': string | Date | Dayjs;
		'vat': id;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'label': string;
		'updatedAt': string;
	};	

	@doc.number declare bankDelay: number;
	@doc.model(DeliverableTemplateModel) declare deliverableTemplate: DeliverableTemplateModel;
	@doc.model(ExpirationTypeModel) declare expirationType: ExpirationTypeModel;
	@doc.boolean declare isMultiVariant: boolean;
	@doc.string declare label: string;
	@doc.boolean declare manualValidation: boolean;
	@doc.number declare maxQuantityPerOrder: number;
	@doc.boolean declare onlySoldInBundle: boolean;
	@doc.model(ProductTemplateStatusModel) declare productTemplateStatus: ProductTemplateStatusModel;
	@doc.model(ProductTypeModel) declare productType: ProductTypeModel;
	@doc.model(VatModel) declare vat: VatModel;
}